// Archivo generado automáticamente desde variables de entorno
// NO EDITAR MANUALMENTE - Este archivo se sobrescribe en cada build

export const environmentConfig = {
  "ENCRYPTION_KEY": "DomoBlock2024@SecretKey!Dev",
  "NODE_ENV": "development"
};
